module.exports = __webpack_public_path__ + "static/media/cert_105-tc.ab3a5c03.jpg";